import { getClient } from '@/api/app';
import logo from 'IMAGE/header/cloud-logo.png';
import logom from 'IMAGE/header/cloud-m-logo.png';
import footerLogo from 'IMAGE/footer/cloud-footer-logo.png';
import CONFIG from '@reolink-web/config-center';

/**
 * 全局配置
 */

import featureList from './features';
import { IGetCloudCountriesResponse } from '@reolink-cloud/interface';
const isProduction = process.env.NODE_ENV === 'production' && process.env.CLOUD_ENV === 'production';
const timeStamp = process.env.TIME_STAMP!;

/**
 * 判断当前客户端
 */
const client = getClient();
const platform = ( client === 'IOS' || client === 'Android' ) ? 'app' : 'web';
const oem = 'reolink';
const reolink = CONFIG.OFFICIAL_URL;
const accountCenter = CONFIG.ACCOUNT_CENTER_URL;
const api = CONFIG.API_URL;
const envFlag = process.env.CLOUD_ENV ?? 'develop';
const officialStore = `https://store.${CONFIG.OFFICIAL_HOST}`;
const cookieDomain = CONFIG.OFFICIAL_COOKIE_DOMAIN;
const videoCdn = 'cdn.reolink.com';
const imgCdn = 'https://a.camovue-static.com';
const originUrl = CONFIG.CLOUD_URL;

// Mon Apr 10 2023 15:00:00 GMT+0800 (中国标准时间)
const basicPlanVersionTime = 1681110000000;

const envFlagString = envFlag === '' ? '' : envFlag + '.';
const version = 'v2';
export const config = {
    // 是否开启debuger模式
    isDebug: false,
    envFlag: envFlag,
    envFlagString: envFlagString,
    // 语言
    lang: 'en',
    langList: [
        'en',
        'de',
        // 'fr',
        'es'
        // 'it'
        // 'jp'
    ],
    isProduction,
    // 版本号 v1.0 || v9.9
    version: version,
    // url请求头
    // urlHead: `${api}/${this.version}`,
    reolink: reolink,
    baseUrl: `${api}/`,
    cloudVideoPageUnit: 80,
    accountCenterLoginUrl: `${accountCenter}/login`,
    accountCenterOauth2Url: `${accountCenter}/oauth2/start`,
    accountCenterSignupUrl: `${accountCenter}/login#signup`,
    accountCenterProfileUrl: `${accountCenter}/`,
    accountCenterSecurityUrl: `${accountCenter}/#account`,
    accountCenterLogoutUrl: `${accountCenter}/logout`,
    accountCenterTotpUrl: `${accountCenter}/?open=totp&current=security`,
    accountCenterE2EEManagerUrl: `${accountCenter}/?current=security&open=protection`,
    accountCenterResetPinUrl: `${accountCenter}/?current=security&open=protection&method=resetCode`,
    myPaymentUrl: `${reolink}/my-payment/`,
    s3ProUrl: 'https://s3.amazonaws.com/reolink-storage/website/uploads/cloudproducts/',
    clientId: CONFIG.CLOUD_CLIENT_ID,
    client: client,
    defaultAvatar: `https://home-cdn.reolink.us/wp-content/uploads/2018/06/default-avatar.png?sv=${timeStamp}`,
    subscribeUrl: 'https://reolink.campgn4.com/Subscribe-Us',
    facebookUrl: 'https://www.facebook.com/ReolinkTech/',
    feature: featureList,
    twitterUrl: 'https://twitter.com/ReolinkTech',
    signipRedirect: `${accountCenter}/login?redirect=${window.location.origin}/user/cloud-library/#signup`,
    contact_us: `${originUrl}/contact-us/`,
    conditions: `${reolink}/terms-conditions/`,
    privacy: `${reolink}/privacy-policy/`,
    app_store: 'https://itunes.apple.com/us/app/reolink/id995927563?ls=1&mt=8',
    google_play: 'https://play.google.com/store/apps/details?id=com.mcu.reolink',
    about_us: 'https://reolink.com/about-us/',
    support_email: 'support@reolink.com',
    ga_enabled: true,
    support_url: 'https://support.reolink.com/hc/en-us/articles/360005747553',
    firmware_url: `${reolink}/firmware/`,
    cloud_support: 'https://support.reolink.com/hc/en-us/sections/360001678454-Cloud',
    logo: `https://home-cdn.reolink.us/wp-content/uploads/2017/02/reolink-logo.png`,
    platform: platform,
    support_team: 'https://support.reolink.com/hc/en-us/requests/new',
    support_cloud_url: 'https://support.reolink.com/hc/en-us/sections/360001541294-Cloud-Settings',
    support_view_url: 'https://support.reolink.com/hc/en-us/articles/13200357180441',
    support_video_protection_promote_url: 'https://support.reolink.com/hc/en-us/articles/18208181849241/',
    support_video_how_to_protection_url: 'https://support.reolink.com/hc/en-us/articles/18210730725145/',
    support_video_protection_explain: 'https://support.reolink.com/hc/en-us/articles/18210730725145/',
    beta_plan_title: 'Beta Plan',
    basic_plan_title: 'Basic Plan',
    business_plan_title: 'Business Plan',
    officialStore: officialStore,
    totpFaq: `https://support.reolink.com/hc/en-us/articles/7362536940569`,
    cookieDomain: cookieDomain,
    downloadCenter: 'https://reolink.com/software-and-manual/',
    plan_disabled_support: 'https://support.reolink.com/hc/en-us/articles/9604648154009',
    legacy_plan_support: 'https://support.reolink.com/hc/en-us/articles/17770178751385-Introduction-to-Legacy-Cloud-Plan/',
    how_to_use_traffic: 'https://support.reolink.com/hc/en-us/articles/13200357180441-Introduction-to-Reolink-View-Service-Beta-/#h_01GKJQ08115BA53VAZZXBSMTCC',
    user_guide_traffic: 'https://support.reolink.com/hc/en-us/articles/13200357180441/',
    videoCdn,
    imgCdn,
    oem,
    originUrl,
    basicPlanVersionTime,
    urlHead: `${api}/${version}`,
    componentPathPrefix: '@/view/reolink',
    headerLogo: logo,
    footerLogo: footerLogo,
    logoM: logom,
    no_sim_support: 'https://support.reolink.com/hc/en-us/articles/41380661370521/',
    richNotificationSupport: 'https://support.reolink.com/hc/en-us/articles/10883740871833/',
    helpMeChooseSupport: 'https://support.reolink.com/hc/en-us/articles/360008997773/',
    showSimDeviceInfo: false,
    showRefundWarning: false,
    fallbackCountry: 'US',
    fallbackLocale: 'en-US',
    ai_support: 'https://support.reolink.com/hc/en-us/articles/48566734883481/',
    e2ee_support: 'https://support.reolink.com/hc/en-us/articles/18208181849241-Overview-of-Reolink-Advanced-Data-Protection/',
    aiFeatures: ['smartAiSearch', 'smartAiCaption', 'smartAiSummary'] as const,
    partnerUrl: `${reolink}/distributor-reseller/?comeFrom=cloud#join-us`,
    howToBind: 'https://support.reolink.com/hc/en-us/articles/360005747553',
    showCloudPlanAutoRenew: true,
    showCloudPlanBatchRenew: true,
    countryData: {} as IGetCloudCountriesResponse
};

export const setConfig = ( key: string, value: unknown ): void => {

    config[ key ] = value;

};
